import React, { createContext, useState, useEffect, ReactNode } from 'react';
import i18n from '../../i18n';

interface LanguageContextType {
  language: string; // "en", "de", ...
  changeLanguage: (lang: string) => void;
}

export const LanguageContext = createContext<LanguageContextType | null>(null);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider = ({ children }: LanguageProviderProps) => {
  const [language, setLanguage] = useState<string>('en');

  useEffect(() => {
    const stored = localStorage.getItem('unyLanguage');
    const lng = stored || 'en';
    setLanguage(lng);
    i18n.changeLanguage(lng); // ✅ sync i18next on boot
  }, []);

  const changeLanguage = (lng: string) => {
    localStorage.setItem('unyLanguage', lng);
    setLanguage(lng);
    i18n.changeLanguage(lng); // ✅ sync i18next when user changes
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
